import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { IFieldSpecs } from 'libraries/module/formbuilder/fields/interfaces/field-specs';
import { defaultBlockCategoryConfig, IBlockCategoryConfig } from "app_quotation/shared/configurationDefaults/blockCategoryConfiguration";
import { Yii } from "libraries/interfaces/Yii";
import { ConfigurationResourceService } from "libraries/service/resources/configuration/configurationResource.service";
import { QuotationBlockCategoryCodeEnum } from "libraries/interfaces/quotation-block-category-code.enum";

@Component({
    selector: 'td-block-title',
    template: `
        <ng-template #template>
            <td mat-cell class="block-data block-title {{parity}}" [attr.colspan]="colspan" [class.has-day]="colspan === 1">
                <div class="title-container">
                    <div class="category-icon-container" *ngIf="!isEmpty && icon">
                        <fa-icon [icon]="icon | iconNameToDefinition"></fa-icon>
                    </div>
                    <div class="title">
                        {{title}}
                    </div>
                </div>
            </td>
        </ng-template>
    `,
    styles: [`
        :host {
            display: none
        }

        td {
            position: sticky;
            z-index: 1;
            font-size: 1rem;
            border-right: 1px solid white;
            border-bottom: 1px solid white;
            left: 10px;
            padding : .75rem;
        }
        td.has-day{
            left: 60px;
        }
        td.odd{
            background : #ecedef;
        }
        td.even{
            background : #f1f1f1;
        }

        .title-container {
            display: flex;
        }

        .category-icon-container {
            width: 32px;
            margin-right: .75rem;
            text-align: center;
        }

        .title {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: 220px;
        }
    `],
})

export class TdBlockTitleComponent implements OnInit {
    @Input()
    public isTripLandQuoteBlock: boolean;

    @Input()
    public isEmpty: boolean;

    @Input()
    public fieldConfig: IFieldSpecs;

    public icon: string;

    @Input()
    public title: string;

    @Input()
    public label: string;
    @Input()
    public colspan: number;
    @Input()
    public category: string;

    @Input()
    public parity: "odd" | "even" = "odd";
    public blockCategoryConfiguration: Map<string, IBlockCategoryConfig>;

    @ViewChild('template', {read: TemplateRef, static: true})
    private readonly template: TemplateRef<{}>;

    constructor(
        private readonly viewContainerRef: ViewContainerRef,
        private readonly configurationResourceService: ConfigurationResourceService,
    ) {}

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);

        this.configurationResourceService
            .get([ 'wui', 'app_quotation', 'config', 'json-configuration', 'block-category.json' ], defaultBlockCategoryConfig)
            .subscribe((config: IBlockCategoryConfig[]) => {
                this.blockCategoryConfiguration = new Map<string, IBlockCategoryConfig>();
                config.forEach((item: IBlockCategoryConfig) => {
                    this.blockCategoryConfiguration.set(item.code.toLowerCase(), item);
                });
                this.icon = this.getIcon(this.category);
            });
    }

    public getIcon(category: string): string {
        const misc: IBlockCategoryConfig = {
            code: QuotationBlockCategoryCodeEnum.misc,
            icon: "fa fa-dollar",
            wording: Yii.t('wui-quotation-js', 'divers')
        };
        if (this.blockCategoryConfiguration && category) {
            return (this.blockCategoryConfiguration.get(category.toLowerCase()) || misc).icon;
        }
        return null;
    }
}
